import { takeLatest } from 'redux-saga/effects';
import { LOAD } from 'model/payALoan';
import { load } from 'sdk/payALoan';
import { callAction, ORM } from '../util';

export default function* saga() {
  yield takeLatest(
    LOAD.ACTION,
    callAction({ api: load, dataName: ORM, type: LOAD })
  );
}
